import { connect } from 'react-redux';
import { actions } from '../../../../../../redux/modules/reports/resutados';
import { getMe } from "../../../../../../redux/modules/cuenta/login";
import ResultadosReport from './ResultadosReport';

const mstp = state => {
    return { ...state.resultados }
};

const mdtp = {
    ...actions, getMe
};

export default connect(mstp, mdtp)(ResultadosReport)
